import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import { Formik, Form } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { ActionSection, InputGroup, ModalHeader, PrimaryAction, ReplicateContent, ReplicateHeader, ReplicateSection, ReplicateSelectionCard, ReplicateSubtitle, ReplicateTitle, ScrollableContent, SideCancelBtn, SubmitBtn, Wrapper } from "../Styles/InputStyles";
import CategoryCard from "../CategoryCard";
import SinglePropSelectModal from "../SinglePropSelectModal";
import MultiPropSelectModal from "../MultiPropSelectModal";

const RentingStayRulesModal = ({
  onClose,
  settingsData,
  editRentingDetailMutate,
  editRentingDetailLoading,
  property,
  propertyList,
  propertyParam,
  rentingDetailsMutate,
  isLoading,
  isDataLoaded,
  setIsEditing,
  isEditing,
  selectedProperties,
  setSelectedProperties
}) => {
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [showPropertyModal, setShowPropertyModal] = useState(false);
  const [showMultiSelectModal, setShowMultiSelectModal] = useState(false);
  const [height, setHeight] = useState(window.innerHeight);
  const [selectedProperty, setSelectedProperty] = useState();
  const [selectedPropertyId, setSelectedPropertyId] = useState(propertyParam);
  const [isPropertyChanging, setIsPropertyChanging] = useState(false);
  const [isReplicating, setIsReplicating] = useState(false);
  const allProperties = propertyList || [];

  useEffect(() => {
    if (propertyParam && filteredProperties.length > 0) {
      const propertyFromParam = filteredProperties.find(prop => prop.id === propertyParam);
      if (propertyFromParam && propertyFromParam.id !== selectedPropertyId) {
        setSelectedProperty(propertyFromParam);
        setSelectedPropertyId(propertyFromParam.id);
      }
    }
  }, [propertyParam, filteredProperties]);

  useEffect(() => {
    if (propertyList) {
      const filtered = propertyList.filter(prop => prop.id !== 0)
      setFilteredProperties(filtered);
      // if (filtered.length > 0) {
      //   const defaultProperty = filtered.find(prop => prop.id === propertyParam) || filtered[0];
      //   setSelectedProperty(defaultProperty);
      // }
      if (filtered.length > 0 && !selectedProperty) {
        let initialProperty;

        if (propertyParam && propertyParam !== 0) {
          initialProperty = filtered.find(prop => prop.id === propertyParam);
        }

        if (!initialProperty) {
          initialProperty = filtered[0];
        }

        setSelectedProperty(initialProperty);
        setSelectedPropertyId(initialProperty.id);
      }
    }
  }, [propertyList, propertyParam]);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // useEffect(() => {
  //   if (propertyParam) {
  //     setSelectedPropertyId(propertyParam);
  //   }
  // }, [propertyParam]);
  useEffect(() => {
    if (propertyParam && propertyParam !== selectedPropertyId) {
      setSelectedPropertyId(propertyParam);

      if (filteredProperties.length > 0) {
        const propertyFromParam = filteredProperties.find(prop => prop.id === propertyParam);
        if (propertyFromParam) {
          setSelectedProperty(propertyFromParam);
        }
      }
    }
  }, [propertyParam, filteredProperties]);

  const initialValues = {
    rent: settingsData?.rent || 0,
    security: settingsData?.security || "0",
    lockInPeriod: settingsData?.lockInPeriod || "",
    noticePeriod: settingsData?.noticePeriod || "",
    agreementDuration: settingsData?.agreementDuration || "",
    rentalCycle: settingsData?.rentalCycle || "",
  };

  const rentalCycle = [
    { label: "1st to 1st", value: "01" },
    { label: "15th to 15th", value: "15" },
    { label: "Move-In Date", value: "00" },
  ];

  const handleSubmit = (values) => {
    if (!values.security) {
      toast.error("Security is required");
      return;
    }
    if (!values.rentalCycle) {
      toast.error("Rental Cycle is required");
      return;
    }
    if (!values.lockInPeriod) {
      toast.error("Lock-in Period is required");
      return;
    }
    if (!values.noticePeriod) {
      toast.error("Notice Period is required");
      return;
    }
    if (!values.agreementDuration) {
      toast.error("Agreement Duration is required");
      return;
    }

    const submitData = {
      ...values,
      selectedPropertyId: selectedPropertyId,
      selectedProperties: [selectedPropertyId]

    };
    editRentingDetailMutate(submitData);
  };

  const handleReplicateSettings = () => {
    if (selectedProperties.length === 0) {
      setShowMultiSelectModal(true);
      return;
    }

    setIsReplicating(true);

    const submitData = {
      rent: settingsData?.rent || 0,
      security: settingsData?.security || "0",
      lockInPeriod: settingsData?.lockInPeriod || "",
      noticePeriod: settingsData?.noticePeriod || "",
      agreementDuration: settingsData?.agreementDuration || "",
      rentalCycle: settingsData?.rentalCycle || "",
      selectedProperties: selectedProperties,
      replicate: 1,
      selectedPropertyId: selectedPropertyId
    };

    editRentingDetailMutate(submitData, {
      onSuccess: () => {
        setIsReplicating(false);
        setIsEditing(false)
        setSelectedProperties([]);
      },
      onError: () => {
        setIsReplicating(false);
      }
    });
  };

  const handleSelectedProperty = (selectedOption) => {

    // const newPropertyId = selectedOption.id;
    const newPropertyId = selectedOption.id;
    if (newPropertyId === selectedPropertyId) {
      return;
    }
    setIsPropertyChanging(true);
    setSelectedProperty(selectedOption);
    setSelectedPropertyId(newPropertyId);

    if (newPropertyId && rentingDetailsMutate) {
      rentingDetailsMutate(newPropertyId, {
        onSettled: () => {
          setIsPropertyChanging(false);
        }
      });
    }
  };

  const handleMultiPropertySave = (selectedProps) => {
    setSelectedProperties(selectedProps);
    setShowMultiSelectModal(false);
  };

  const renderSelectedProperties = (selected = []) => {
    if (!selected.length) return "No properties selected";

    if (selected.length === allProperties.length) {
      return "All Properties";
    }

    const selectedPropertyNames = allProperties
      .filter((prop) => selected.includes(prop.id))
      .map((prop) => prop.name);

    if (!selectedPropertyNames.length) return "No properties selected";

    const maxToShow = 2;
    const namesToShow = selectedPropertyNames.slice(0, maxToShow);
    const remainingCount = selectedPropertyNames.length - maxToShow;

    return (
      <PropertyDisplayContainer>
        {namesToShow.join(", ")}
        {remainingCount > 0 && (
          <RemainingCount>+{remainingCount}</RemainingCount>
        )}
      </PropertyDisplayContainer>
    );
  };

  return (
    <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
      <ModalHeader>
        <HeaderTitle>{isEditing ? "Edit Agreement Rules" : "Agreement Rules"}</HeaderTitle>
        <CloseButton onClick={onClose}>
          <MdClose color="white" size={24} />
        </CloseButton>
      </ModalHeader>

      {isLoading || !isDataLoaded ? (
        <div className="flex items-center justify-center h-full">
          <CircularProgress />
        </div>
      ) : (
        <>
          <ContentContainer>
            <div className={isEditing ? "px-6 py-0" : "px-6 pt-6 pb-20"}>
              <Section>
                {!isEditing && property?.id === 0 && (
                  // <PropertySection>
                    <CategoryCard
                      title="Property"
                      selectedCategory={selectedProperty}
                      onClick={() => setShowPropertyModal(true)}
                    />
                  // </PropertySection>
                )}

                {isEditing ? (
                  <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                  >
                    {({ values, handleChange, errors, touched }) => (
                      <Form>
                        <ScrollableContent className="max-h-[calc(100vh-140px)]">
                          <Wrapper>
                            <InputGroup>
                              <Label>Security (₹)</Label>
                              <Input
                                id="security"
                                type="number"
                                name="security"
                                value={values.security}
                                onChange={handleChange}
                              />
                              {touched.security && errors.security && <Error>{errors.security}</Error>}
                            </InputGroup>
                            <InputGroup>
                              <Label>Lock-in Period (Months)</Label>
                              <Select
                                name="lockInPeriod"
                                value={values.lockInPeriod}
                                onChange={handleChange}
                                className="w-full pl-2"
                                style={{ height: "46px" }}
                              >
                                {[...Array(12).keys()].map((num) => {
                                  const value = (num + 1) * 1;
                                  return (
                                    <MenuItem key={value} value={value}>
                                      {value}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              {touched.lockInPeriod && errors.lockInPeriod && (
                                <Error>{errors.lockInPeriod}</Error>
                              )}
                            </InputGroup>
                            <InputGroup>
                              <Label>Notice Period (Months)</Label>
                              <Select
                                name="noticePeriod"
                                value={values.noticePeriod}
                                onChange={handleChange}
                                className="w-full pl-2"
                                style={{ height: "46px" }}
                              >
                                {[...Array(24).keys()].map((num) => {
                                  const value = (num + 1) * 0.5;
                                  return (
                                    <MenuItem key={value} value={value}>
                                      {value}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              {touched.noticePeriod && errors.noticePeriod && (
                                <Error>{errors.noticePeriod}</Error>
                              )}
                            </InputGroup>
                            <InputGroup>
                              <Label>Agreement Duration (Months)</Label>
                              <Select
                                name="agreementDuration"
                                value={values.agreementDuration}
                                onChange={handleChange}
                                className="w-full pl-2"
                                style={{ height: "46px" }}
                              >
                                {[...Array(12).keys()].map((num) => {
                                  const value = (num + 1) * 1;
                                  return (
                                    <MenuItem key={value} value={value}>
                                      {value}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              {touched.agreementDuration && errors.agreementDuration && (
                                <Error>{errors.agreementDuration}</Error>
                              )}
                            </InputGroup>
                            <InputGroup>
                              <Label>Rental Cycle (Days)</Label>
                              <Select
                                name="rentalCycle"
                                value={values.rentalCycle}
                                onChange={handleChange}
                                className="w-full pl-2"
                                style={{ height: "46px" }}
                              >
                                {rentalCycle.map((mode) => (
                                  <MenuItem key={mode.value} value={mode.value}>
                                    {mode.label}
                                  </MenuItem>
                                ))}
                              </Select>
                              {touched.rentalCycle && errors.rentalCycle && (
                                <Error>{errors.rentalCycle}</Error>
                              )}
                            </InputGroup>
                          </Wrapper>
                        </ScrollableContent>
                        <ActionSection $isEditing={isEditing}>
                          <SideCancelBtn
                            type="button"
                            $isEditing={isEditing}
                            onClick={() => setIsEditing(false)}
                          >
                            Back
                          </SideCancelBtn>
                          <SubmitBtn $isEditing={isEditing} type="submit" disabled={editRentingDetailLoading}>
                            {editRentingDetailLoading ? "Updating..." : "Update"}
                          </SubmitBtn>
                        </ActionSection>
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <>
                    {isPropertyChanging ? (
                      <div className="flex items-center justify-center h-full pt-10">
                        <CircularProgress />
                      </div>
                    ) : (
                      <>
                        {/* <ScrollableContent className="max-h-[calc(100vh-140px)]"> */}
                        <SettingsGrid>
                          {/* <SettingCard>
                            <SectionTitle>Rent & Agreement Details</SectionTitle>
                            <SettingContent className="px-5 py-3">
                              <Label>Security</Label>
                              <Value>{"₹" + (settingsData?.security || 0)}</Value>
                            </SettingContent>
                            <SettingContent className="px-5 pb-3 pt-0">
                              <Label>Lock-in Period</Label>
                              <Value>{settingsData?.lockInPeriod || 0} Month{settingsData?.lockInPeriod > 1 ? 's' : ''}</Value>
                            </SettingContent>
                            <SettingContent className="px-5 pb-3 pt-0">
                              <Label>Notice Period</Label>
                              <Value>{settingsData?.noticePeriod || 0} Month{settingsData?.noticePeriod > 1 ? 's' : ''}</Value>
                            </SettingContent>
                            <SettingContent className="px-5 pb-3 pt-0">
                              <Label>Agreement Duration</Label>
                              <Value>{settingsData?.agreementDuration || 0} Month{settingsData?.agreementDuration > 1 ? 's' : ''}</Value>
                            </SettingContent>
                            <SettingContent className="px-5 pb-3 pt-0">
                              <Label>Rent Addition Cycle</Label>
                              <Value>
                                {settingsData?.rentalCycle === '00'
                                  ? 'Move-In Date'
                                  : `${settingsData?.rentalCycle || '01'} to ${settingsData?.rentalCycle || '01'}`
                                }
                              </Value>
                            </SettingContent>
                          </SettingCard> */}
                          {/* <SettingsGrid> */}

                            <SettingCard>

                              <SectionHeader>
                                <SectionTitle>Rent & Agreement</SectionTitle>
                              </SectionHeader>

                              <SettingRow>
                                <Label>Security Deposit</Label>
                                <Value>₹{settingsData?.security || 0}</Value>
                              </SettingRow>

                              <SettingRow>
                                <Label>Minimum Stay</Label>
                                <Value>
                                  {settingsData?.lockInPeriod || 0} Month{settingsData?.lockInPeriod > 1 ? "s" : ""}
                                </Value>
                              </SettingRow>

                              <SettingRow>
                                <Label>Notice Period</Label>
                                <Value>
                                  {settingsData?.noticePeriod || 0} Month{settingsData?.noticePeriod > 1 ? "s" : ""}
                                </Value>
                              </SettingRow>

                              <SettingRow>
                                <Label>Agreement Duration</Label>
                                <Value>
                                  {settingsData?.agreementDuration || 0} Month{settingsData?.agreementDuration > 1 ? "s" : ""}
                                </Value>
                              </SettingRow>

                              <SettingRow>
                                <Label>Billing Cycle</Label>
                                <Value>
                                  {settingsData?.rentalCycle === '00'
                                    ? 'On Move-in Date'
                                    : `${settingsData?.rentalCycle || '01'} → ${settingsData?.rentalCycle || '01'}`}
                                </Value>
                              </SettingRow>

                            </SettingCard>

                          {/* </SettingsGrid> */}


                          {/* Replicate Settings Section - Only in view mode */}
                          {/* <ReplicateSection>
                            <ReplicateHeader>
                              <ReplicateTitle>Replicate Settings to Other Properties</ReplicateTitle>
                            </ReplicateHeader>

                            <ReplicateContent>
                              <PropertiesSelection>
                                <CategoryCard
                                  type="button"
                                  selectedCategory={selectedProperties.length > 0 ? {
                                    label: renderSelectedProperties(selectedProperties),
                                    value: "properties"
                                  } : null}
                                  title="Property or Properties"
                                  onClick={() => setShowMultiSelectModal(true)}
                                />

                                <NewPackage
                                  onClick={handleReplicateSettings}
                                  disabled={isLoading || selectedProperties.length === 0 || isReplicating}
                                >
                                  {isReplicating ? "Replicating..." : `Replicate to ${selectedProperties.length} Properties`}
                                </NewPackage>

                              </PropertiesSelection>
                            </ReplicateContent>
                          </ReplicateSection> */}
                          <ReplicateSection>

                            {/* Header */}
                            <ReplicateHeader>
                              <ReplicateTitle>
                                Apply Settings to Other Properties
                              </ReplicateTitle>
                              <ReplicateSubtitle>
                                Instantly copy these settings across selected properties
                              </ReplicateSubtitle>
                            </ReplicateHeader>

                            <ReplicateContent>

                              {/* Selection Card */}
                              <ReplicateSelectionCard
                                type="button"
                                onClick={() => setShowMultiSelectModal(true)}
                              >
                                <div>
                                  <p className="text-sm font-medium text-gray-700">
                                    Select Properties
                                  </p>
                                  <p className="text-xs text-gray-500 mt-0.5">
                                    {selectedProperties.length > 0
                                      ? renderSelectedProperties(selectedProperties)
                                      : "Choose one or more properties"}
                                  </p>
                                </div>

                                <span className="text-primary-color text-sm font-medium">
                                  {selectedProperties.length > 0 ? "Edit" : "Select"}
                                </span>
                              </ReplicateSelectionCard>

                              {/* CTA Button */}
                              <PrimaryAction
                                onClick={handleReplicateSettings}
                                disabled={isLoading || selectedProperties.length === 0 || isReplicating}
                              >
                                {isReplicating
                                  ? "Applying..."
                                  : selectedProperties.length > 0
                                    ? `Apply to ${selectedProperties.length} Properties`
                                    : "Select Properties First"}
                              </PrimaryAction>

                            </ReplicateContent>
                          </ReplicateSection>
                        </SettingsGrid>

                        {/* </ScrollableContent> */}

                        <ActionSection $isEditing={isEditing}>
                          <SideCancelBtn
                            type="button"
                            onClick={onClose}
                          >
                            Cancel
                          </SideCancelBtn>
                          <SubmitBtn $isEditing={isEditing} onClick={() => setIsEditing(true)}>
                            Edit
                          </SubmitBtn>
                        </ActionSection>
                      </>
                    )}
                  </>
                )}
              </Section>
            </div>

            {/* Single Property Selection Modal */}
            <SinglePropSelectModal
              isOpen={showPropertyModal}
              onClose={() => setShowPropertyModal(false)}
              onSelect={handleSelectedProperty}
              options={filteredProperties}
              selectedProperty={selectedProperty}
            />

            {/* Multi Property Selection Modal */}
            <MultiPropSelectModal
              isOpen={showMultiSelectModal}
              onClose={() => setShowMultiSelectModal(false)}
              onSelect={handleMultiPropertySave}
              options={filteredProperties}
              selectedProperties={selectedProperties}
            />
          </ContentContainer>
        </>
      )}
    </Container>
  );
};

// Styled Components
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] p-4`;
const HeaderTitle = tw.h1`text-white text-lg font-medium`;
const CloseButton = tw.button``;
const ContentContainer = tw.div`flex-1 overflow-y-auto`;
const Section = tw.div`space-y-6`;
const PropertySection = tw.div`bg-gray-50 rounded-xl p-4 border border-gray-200 mb-4`;
// const SettingsGrid = tw.div`space-y-4`;
// const SettingCard = tw.div`bg-gray-50 rounded-xl border border-gray-200 hover:shadow-md transition-shadow duration-200`;
// const SettingContent = tw.div`flex items-start justify-between space-x-6 p-5`;
// const Label = tw.label`text-sm text-gray-500 font-normal`;
// const Value = tw.span`text-gray-800 font-medium`;


const SettingsGrid = tw.div`space-y-5`;

const SettingCard = tw.div`
  bg-white rounded-xl border border-gray-200 
  shadow-sm hover:shadow-md transition-all duration-200
`;

const SectionHeader = tw.div`
  px-5 pt-5 pb-3 border-b border-gray-100
`;

const SectionTitle = tw.h3`
  text-sm font-semibold text-gray-800
`;

const SettingRow = tw.div`
  flex items-center justify-between 
  px-5 py-3 border-b border-gray-100 last:border-0
`;

const Label = tw.span`
  text-sm text-gray-500
`;

const Value = tw.span`
  text-sm font-semibold text-gray-900
`;

const Input = tw.input`border border-gray-300 rounded h-10 px-2 py-1 focus:ring-1 focus:ring-primary-color focus:border-primary-color focus:outline-none`;
const Error = tw.p`text-rose-600 text-sm`;
//const SectionTitle = tw.h2`text-md font-semibold text-gray-800 mt-4 mx-4`;
const PropertyDisplayContainer = tw.div`flex items-center gap-1 truncate`;
const RemainingCount = tw.span`text-gray-500 ml-1 font-medium`;
// const ReplicateSection = tw.div`bg-blue-50 rounded-xl border border-blue-50 p-4`;
// const ReplicateHeader = tw.div`mb-2`;
// const ReplicateTitle = tw.h4`font-semibold text-primary-color text-lg mb-1`;
// const ReplicateContent = tw.div``;
// const PropertiesSelection = tw.div`space-y-3`;
// const NewPackage = tw.button`w-full border border-primary-color items-center mb-2 text-primary-color h-12 rounded-lg hover:bg-primary-color hover:text-white disabled:opacity-50 disabled:cursor-not-allowed`;

export default RentingStayRulesModal;
